import React from "react";

import { trpc } from "@blis/trpc/react";

type ProductlaneView =
  | "INDEX"
  | "CHANGELOG"
  | "DOCS"
  | "FEEDBACK"
  | "AICHAT"
  | "LIVE_CHAT";

type ProductlaneApi = {
  init: (options: { widgetKey: string; userToken?: string }) => void;
  set: (options: { userToken?: string }) => void;
  open: (view?: ProductlaneView) => void;
  close: () => void;
  toggle: () => void;
  signOut: () => void;
  on: (
    event: "loaded" | "opened" | "closed" | "toggled",
    handler: () => void,
  ) => void;
  off: (
    event: "loaded" | "opened" | "closed" | "toggled",
    handler: () => void,
  ) => void;
};

declare global {
  interface Window {
    Productlane: ProductlaneApi;
  }
}

function getProductlane(): ProductlaneApi | undefined {
  return window.Productlane;
}

export function signOutProductlane() {
  getProductlane()?.signOut();
}

export function useProductlaneChat() {
  const { data: userAuth } = trpc.productlane.userAuth.useQuery();

  React.useEffect(() => {
    const Productlane = getProductlane();
    if (!Productlane || !userAuth?.userToken) {
      return;
    }

    const applyToken = () => {
      Productlane.set({ userToken: userAuth.userToken });
    };

    Productlane.on("loaded", applyToken);
    applyToken();

    return () => {
      Productlane.off("loaded", applyToken);
    };
  }, [userAuth?.userToken]);

  return {
    buttonProps: {
      onPress: () => {
        getProductlane()?.toggle();
      },
    },
  };
}
